import axios from '@/utils/axios'
import queryString from '@/utils/queryString';
import i18n from '@/plugins/i18n';
export default {
    namespaced: true,
    state: {
        purchaseOrder: null,
        purchaseOrders: [],
        pruchaseOrderHeaders: [
            { text: i18n.t('code'), value: 'code' },
            { text: i18n.t('date'), value: 'date' },
            { text: i18n.t('warehouse'), sortable: false, value: 'warehouse' },
            { text: i18n.t('vendor'), sortable: false, value: 'vendor' },
        ]
    },
    mutations: {
        setPurchaseOrder(state, payload) {
            state.purchaseOrder = payload;
        },
        setPurchaseOrders(state, payload) {
            state.purchaseOrders = payload;
        },
        updatePurchaseOrderItemLines(state, payload) {
            state.purchaseOrder.purchase_order_item_lines = payload;
        }
    }, 
    actions: {
        storePurchaseOrder({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url:`${rootState.purchase.routePrefix}/purchase-orders`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        updatePurchaseOrder({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `${rootState.purchase.routePrefix}/purchase-orders/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removePurchaseOrder({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.purchase.routePrefix}/purchase-orders/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removePurchaseOrders({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.purchase.routePrefix}/purchase-orders`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        fetchPurchaseOrder({ commit, rootState, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.purchase.routePrefix}/purchase-orders/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setPurchaseOrder', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                } 
                );
            })
        },
        fetchPurchaseOrders({ commit, rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.purchase.routePrefix}/purchase-orders?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setPurchaseOrders', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        },
        updatePurchaseOrderItemLines({commit}, payload) {
            commit('updatePurchaseOrderItemLines', payload);
        }
    }
}